module.exports = __webpack_public_path__ + "static/section-3-370cabf389ecf41baba716e042878c94.svg";